import axios from '../axios';
import {EmailConfig} from "../interfaces/EmailConfig";
import {get} from "../fetch";


export function getAppConfiguration() {
  return axios.get(`/api/config`).then((response) => response.data);
}

export function getConfiguration() {
  return axios.get(`/api/configuration`).then((response) => response.data);
}

export function updateConfiguration(config) {
  return axios.put(`/api/configuration`, config).then((response) => response.data);
}

export function uploadImage(file) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return axios.post(`/api/configuration/upload`, file, config).then((response) => response.data);
}

export function smtpTest(smtpConfig) {
  return axios.post(`/api/configuration/smtp-test`, smtpConfig).then((response) => response.data);
}

export function getEmailConfig(key: string) {
  return get(`/api/configuration/email/${key}`);
}

export function updateEmailConfig(key: string, config: EmailConfig) {
  return axios.put(`/api/configuration/email/${key}`, config).then((response) => response.data);
}
